"use client"

import styles from "@styles/TaskCard.module.css"
import clsx from "clsx"
import { Icon, IconName, IconSize } from "../../icons/Icon"

export function TaskSource({
  source,
}: {
  source: "slack" | "email" | "meeting"
}) {
  const icon = {
    slack: IconName.BubbleAnnotation6,
    email: IconName.Email3,
    meeting: IconName.Calendar1,
  }[source]

  const color = {
    slack: "#793AAF",
    email: "#0067D6",
    meeting: "#A35200",
  }[source]

  return (
    <div className={clsx("callout", styles.sourceContainer, styles[source])}>
      <Icon name={icon} size={IconSize.Small} customColor={color} />
      <span style={{ color: color }}>
        {source.charAt(0).toUpperCase() + source.slice(1)}
      </span>
    </div>
  )
}
